/** Widget embed strings — English in englishWidgetLabels.js; Danish here; sv/no in nordicWidgetLabels.js */

import { en } from './englishWidgetLabels.js';
import { sv, no } from './nordicWidgetLabels.js';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from './locales.js';

const da = {
  live: 'LIVE',
  upcoming: 'Kommende',
  fullTime: 'Slut',
  vs: 'mod',
  noMatches: 'Ingen kampe tilgængelige.',
  noData: 'Ingen data tilgængelig.',
  goals: 'Mål',
  assists: 'Assists',
  appearances: 'Kampe',
  minutes: 'Min',
  played: 'K',
  won: 'V',
  drawn: 'U',
  lost: 'T',
  points: 'P',
  form: 'Form',
  position: 'Pos',
  player: 'Spiller',
  team: 'Hold',
  coach: 'Træner',
  venue: 'Stadion',
  referee: 'Dommer',
  attendance: 'Tilskuere',
  halfTime: 'Pause',
  overall: 'SAMLET',
  all: 'Alle',
  home: 'Hjemme',
  away: 'Ude',
  teamList: 'Holdliste',
  teamProfile: 'Holdprofil',
  playerList: 'Spillerliste',
  playerProfile: 'Spillerprofil',
  status: 'Status',
  matchCoaches: 'Kampens trænere',
  headCoach: 'Cheftræner',
  nationality: 'Nationalitet',
  age: 'Alder',
  appointed: 'Træner siden',
  formation: 'Formation',
  opponent: 'Modstander',
  touchline: 'Trænerbænk',
  homeVenue: 'Hjemmebane',
  goalsFor: 'MF',
  goalsAgainst: 'MI',
  goalDifference: 'MD',
  squadPlayers: 'spillere i truppen',
  fullSquad: 'Fuld trup',
  selectTeamSquad: 'Vælg et hold',
  selectTeamSquadHint:
    'Brug hold-dropdown over forhåndsvisningen for at hente alle spillere for klubben.',
  noSquadData: 'Ingen trupdata for dette hold i feedet.',
  captain: 'Anfører',
  injured: 'Skadet',
  rating: 'Rating',
  cards: 'Kort',
};

const catalogs = { en, da, sv, no };

export const LOCALES = SUPPORTED_LOCALES;

export function getWidgetLabels(locale = DEFAULT_LOCALE) {
  const dict = catalogs[locale] || catalogs.en;
  return (key) => dict[key] ?? catalogs.en[key] ?? key;
}
